import React, { forwardRef } from 'react';
import { ArrowDown } from 'lucide-react';

const ScrollDownButton = forwardRef(function ScrollDownButton(
    { bottom, left = '0', onClick, ariaLabel = 'Scroll to bottom', isEmbedded = false },
    ref,
) {
    const positionClass = isEmbedded ? 'absolute' : 'fixed';
    const effectiveLeft = isEmbedded ? '0' : left;
    const horizontalPaddingClass = isEmbedded ? 'px-4 sm:px-6' : 'px-4 sm:px-8';
    return (
        <div
            ref={ref}
            className={`${positionClass} right-0 ${horizontalPaddingClass} z-30 pointer-events-none`}
            style={{ display: 'none', bottom: `${bottom}px`, left: effectiveLeft }}
        >
            <div className="max-w-3xl w-full mx-auto flex justify-center">
                <button
                    onClick={onClick}
                    aria-label={ariaLabel}
                    className="w-8 h-8 bg-white rounded-full shadow-lg border border-app-border flex items-center justify-center hover:bg-gray-50 transition-all duration-200 pointer-events-auto"
                    style={{ animation: 'fadeInUp 0.3s ease-out' }}
                >
                    <ArrowDown className="w-3.5 h-3.5 text-gray-600" />
                </button>
            </div>
        </div>
    );
});

export default ScrollDownButton;
